import { customizeList, chatList, customizeDaysum, customizeRewards } from '@/services/api';

const newUserRewards = {
  namespace: 'newUserRewards',
  state: {},
  reducers: {},
  effects: {
    *customizeList({ payload }, { call }) {
      const { data = [] } = yield call(customizeList, payload);
      return data || [];
    },
    *chatList({ payload }, { call }) {
      const { data = [] } = yield call(chatList, payload);
      return data || [];
    },
    *customizeDaysum({ payload }, { call }) {
      const { data = {} } = yield call(customizeDaysum, payload);
      return data;
    },
    *customizeRewards({ payload }, { call }) {
      const res = yield call(customizeRewards, payload);
      return res;
    }
  }
};

export default newUserRewards;
